import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	padding: 0 30px;
`;

const StyledTable = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

const StyledTableRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${TextLabel} {
		font-size: 14px;
		color: #000000;

		&:nth-child(1) {
			opacity: 0.5;
		}
	}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.1);
`;

export { StyledContainer, StyledTable, StyledTableRow, StyledDivider };
